module.exports = __webpack_public_path__ + "static/img/shangbiao_23.2c39fab.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/shangbiao_23.png
// module id = ApYD
// module chunks = 0